import { ReactNode } from 'react'

import cn from 'clsx'

import { CloseIcon } from '@App/static/icons/ArrowIcons'

import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'

export const TradeInfoModal = ({
  isOpen,
  setIsOpen,
  children,
  headerContent,
}: ModalTypes & { children?: ReactNode; headerContent?: string }) => {
  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.title}>{headerContent}</div>
          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.content}>{children}</div>
      </div>
    </ModalWrapper>
  )
}
